<template>
  <div class="constructor_scroll">
    <div class="container-block" :class="{container_large: !$store.state.menuDesktopShow}">
      <div class="tittle">
        <div class="breadcrumbs">
          <router-link to="/blog">{{textContent.title}}</router-link>
          <span></span>
          <h1>{{copyItem.title}}</h1>
        </div>
      </div>
      <div class="edit_main">
        <div class="block_flex" v-if="isLoaded">
          <div class="left">
            <div class="folder radius">
              <div class="column caption">
                <p>Основные настройки</p>
              </div>
              <div class="column">
                <div class="content">
                  <new-input title="Название статьи" name="title"></new-input>
                  <calendar name="created_at" title="Дата создания"></calendar>
                  <new-input title="Ссылка" name="url"></new-input>
                  <edit-drop-down field-name="title" title="Автор" :id="parentId.authors" :url="apiUrls.content"
                                  name="author_id"></edit-drop-down>
                  <edit-drop-down field-name="title" title="Категория" :id="parentId.blog" :url="apiUrls.content"
                                  name="parent_id"></edit-drop-down>
                  <edit-file class="short align-top" use-case="cover" v-if="isLoaded" title="Изображение"
                             name="img"></edit-file>
                  <new-input title="Alt" name="seo_alt"></new-input>
                  <div class="list">
                    <p>Настройки отображения</p>
                    <div class="checkbox-group">
                      <checkbox name="show_author" title="Отображать автора"></checkbox>
                      <checkbox name="show_date" title="Отображать дату"></checkbox>
                    </div>
                  </div>
                  <new-text-area title="Краткое описание" name="subtext"></new-text-area>
                </div>
              </div>

            </div>
          </div>
          <div class="right">
            <div class="folder radius">
              <div class="column caption">
                <p>СЕО настройки</p>
              </div>
              <div class="column">
                <div class="content">
                  <new-input title="Название страницы" name="seo_title"></new-input>
                  <new-text-area title="Описание" name="seo_desc"></new-text-area>
                  <new-text-area title="Ключевые слова" name="seo_key"></new-text-area>
                </div>
              </div>
            </div>
          </div>
        </div>
        <insert-album @insertAlbum="insertAlbum($event)"></insert-album>
        <div class="folder radius">
          <div class="column caption">
            <p>Текст статьи</p>
          </div>
          <div class="column">
            <div class="content">
              <div :class="{saved: savedFields.hasOwnProperty('text') && !changedText}">
                <textarea id="editor" name="editor" v-model="text"></textarea>
                <add-image v-if="isLoaded"/>
              </div>
            </div>
          </div>
        </div>
        <div class="buttons">
          <button class="save" @click="onSubmit">{{textContent.saveButton}}</button>
          <button class="cancel" @click="reset">{{textContent.cancelButton}}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import IconUpload from '@/components/icons/IconUpload'
  import NewTextArea from '@/components/edit-form/new-items/TextArea'
  import NewInput from '@/components/edit-form/new-items/Input'
  import OldInput from '@/components/edit-form/old-items/Input'
  import OldTextArea from '@/components/edit-form/old-items/TextArea'
  import OldEditor from '@/components/edit-form/old-items/Editor'
  import EditDropDown from '@/components/edit-form/DropDown'
  import EditFile from '@/components/edit-form/File'
  import {createNamespacedHelpers} from 'vuex'
  import Checkbox from "@/components/edit-form/Checkbox";
  import InsertAlbum from "../../../../edit-form/InsertAlbum";
  import Calendar from '../../../../edit-form/Calendar'
  import AddImage from '@/components/edit-form/AddImage'
import { close } from 'fs';
  const {mapMutations, mapActions, mapState} = createNamespacedHelpers('editPage')



  export default {
    data: function () {
      return {
        editorInstance: '',
        isLoaded: false,
        text: '',
        changedText: false,
        editor: null,
        editorConfig: {
          language: 'ru',
          ckfinder: {
            uploadUrl: this.$store.state.apiDomain + this.$store.state.ckfinderUrl,
            token: localStorage.token
          }
        }
      }
    },
    computed: {
      ...mapState([
        'item',
        'copyItem',
        'textContent',
        'savedFields'
      ]),
      apiUrls() {
        return this.$store.state.apiUrls
      },
      parentId() {
        return this.$store.state.parentId
      }
    },
    methods: {
      ...mapActions([
        'init',
        'edit',
        'reset',
        'updateNews'
      ]),
      ...mapMutations([
        'resetModule',
        'setFileExtensions',
        'setItemField',
        'setEditorInstance'
      ]),
      insertAlbum(code) {
        this.editor.insertText(code)
      },
      onSubmit() {
        this.edit({
          title: this.item.title,
          created_at: this.item.created_at,
          url: this.item.url,
          author_id: this.item.author_id,
          parent_id: this.item.parent_id,
          show_author: this.item.show_author,
          show_date: this.item.show_date,
          subtext: this.item.subtext,
          text: this.editor.getData(),
          img: this.item.img,
          seo_title: this.item.seo_title,
          seo_desc: this.item.seo_desc,
          seo_key: this.item.seo_key,
          seo_alt: this.item.seo_alt,
        })
          .then(data => {
            this.updateNews({
              title: data.article.title,
              id: data.article.id,
              newsId: data.lastNews.id,
              section_id: this.parentId.blog,
              is_active: this.item.is_active,
              url: {
                categoryId: data.article.parent_id,
                articleUrl: data.article.url
              },
              img: data.article.img,
              subtext: data.article.subtext
            })
          })
      }
    },
    created() {
      this.resetModule();
      this.setFileExtensions({img: ['jpg', 'jpeg', 'png', 'gif']})
      this.init({
        textContent: {
          title: 'Блог',
          cancelButton: 'Отмена',
          saveButton: 'Сохранить',
          greeting: 'Все изменения успешно сохранены',
          subtitle: 'Редактирование категории блога',
          seo: 'SEO информация',
          options: 'Прочие настройки',
        },
        errors: {
          title: {message: 'Введите название категории', hasError: false},
          created_at: {message: 'Введите дату создания', hasError: false, isNullable: true},
          url: {message: 'Введите ссылку', hasError: false},
          author_id: {message: 'Выберите автора', hasError: false, isNullable: true},
          parent_id: {message: 'Выберите категорию', hasError: false},
          subtext: {message: 'Напишите краткое описание', hasError: false},
          show_author: {hasError: false, isNullable: true},
          show_date: {hasError: false, isNullable: true},
          seo_alt: {hasError: false, isNullable: true},
          seo_title: {message: 'Введите название страницы', hasError: false},
          seo_desc: {message: 'Напишите краткое описание', hasError: false},
          seo_key: {message: 'Напишите ключевые слова', hasError: false, isNullable: true},
          img: {message: 'Допустимые расширения: jpg, jpeg, png, gif', hasError: false}
        },
        itemId: this.$route.params.id,
        apiUrl: this.apiUrls.content
      }).then(response => {
        this.text = response.text
        this.isLoaded = true;
        this.editor = CKEDITOR.replace('editor')
        this.editor.on('change', () => {
          this.changedText = true
        })
        this.setEditorInstance(this.editor)
        this.setItemField({fieldName: 'created_at', value: this.item.created_at.split(' ')[0]})
      })
    },
    components: {
      Calendar,
      InsertAlbum,
      Checkbox,
      NewTextArea,
      NewInput,
      OldInput,
      OldTextArea,
      OldEditor,
      EditDropDown,
      EditFile,
      IconUpload,
      AddImage
    }
  }
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/blog/articles/pages/Edit.vue